<template>
  <div class="email-input-wrap" v-if="formItem.input_type === 'email'">
    <input
      class="email-input"
      ref="emailInput"
      type="text"
      v-model="inputValue"
      :placeholder="formItem.placeholder"
      @input="formatInput()"
    />
    <img-v3 v-if="hasClear" :src="clearIconUrl" class="clear-icon" @click="clearInput()"/>
    <img-v3 v-if="formItem.submit_img_url" :src="formItem.submit_img_url" class="submit-icon" @click="submitInput" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { showLoadingToast, showToast } from "../../tools/Tip";

export default {
  //cm means commit
  //linked_val,是否受其他组件控制，与linked配合使用
  props: ["formItem", "idx"],
  data() {
    return {
      clearIconUrl: require("../../images/clear@2x.png"),
      hasClear: false,
      inputValue: '',
      sendFlag: false,
    }
  },
  computed: {
    ...mapState(["_ticket"]),

  },
  mounted() {
    this.inputValue = this.formItem.value;
  },
  watch: {

  },
  methods: {
    formatInput() {
      // console.log(this.inputValue)
      this.hasClear = !!this.inputValue;
    },
    clearInput() {
      this.inputValue = '';
    },
    submitInput() {
      let reg = this.formItem.regex;
      if (reg) {
        let r = new RegExp(reg);
        if (r.test(this.inputValue)) {
          // 正则校验通过
          this.sendEmail();
        } else {
          // 正则校验不通过
          showToast(this, {
            type: "error",
            txt: this.formItem.regex_remind
          });
          return;
        }
      } else {
        this.sendEmail();
      }
    },
    sendEmail() {
      if (this.sendFlag) {
        return;
      }
      this.sendFlag = true;
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      up.set("email", this.inputValue);
      // 兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }

      post(this.formItem.submit_url, up)
        .then(data => {
          this.sendFlag = false;
          this.toast.hide();
          showToast(this, {
            type: "correct",
            txt: data.msg
          });
        })
        .catch(res => {
          this.sendFlag = false;
          this.toast.hide();
          showToast(this, {
            type: "error",
            txt: res.errmsg
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
  .email-input-wrap {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 1.1rem;
    margin-top: 0.32rem;
    border-radius: 0.12rem;
    .email-input {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0.34rem 1.9rem 0.34rem 0.24rem;
      background: #F3F7F7;
      border-radius: 0.12rem;
      font-weight: 500;
      font-size: 0.36rem;
      color: #333333;
      vertical-align: bottom;
    }
    .clear-icon {
      position: absolute;
      right: 1.38rem;
      width: 0.32rem;
      height: 0.32rem;
      cursor: pointer;
    }
    .submit-icon {
      position: absolute;
      right: 0;
      width: 1.1rem;
      height: 1.1rem;
      cursor: pointer;
    }
  }

</style>
